import React, { useEffect, useState } from "react";
import {
  Typography,
  Container,
  Button,
  CircularProgress,
  Modal,
  Stack,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import { backend, API_URL } from "../../../config";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import CustomerForm from "../components/Forms/CustomerForm";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const INITIAL_HOURS = {
  mon: null,
  tue: null,
  wed: null,
  thu: null,
  fri: null,
  sat: null,
  sun: null,
};

export const CustomerAdd = (props) => {
  const classes = useStyles();

  const customerId = props.match.params.id;

  const currentUserStore = useSelector((state) => state.current_user);

  const [customer, setCustomer] = useState({
    id: "",
    name: "",
    company_id: "",
    company_location: [],
    company_location_id: [],
    fees: [],
    margins: [],
    surcharges: [],
    operating_hours: INITIAL_HOURS,
  });
  const [customerLoaded, setCustomerLoaded] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [paymentType, setPaymentType] = useState(0); // 0 = no payments, 1 = normal payment, 2 = pay in advance, 3 = cash on delivery

  const handleChange = (e) => {
    const { checked, name, value } = e.target;

    setCustomer((prevState) => {
      let customerObj = { ...prevState };

      if (
        [
          "taxable",
          "units_quickbooks_mappings",
          "fuel_surcharge",
          "payments_enabled",
          "lot_tracking_enabled",
          "customer_editable_orderlist_enabled",
          "cod_payments_enabled",
          "pay_in_advance_enabled",
        ].includes(name)
      ) {
        customerObj = { ...customerObj, [name]: checked };

        if (name === "payments_enabled" && checked) {
          customerObj = {
            ...customerObj,
            cod_payments_enabled: false,
            pay_in_advance_enabled: false,
          };
        } else if (name === "cod_payments_enabled" && checked) {
          customerObj = {
            ...customerObj,
            payments_enabled: false,
            pay_in_advance_enabled: false,
          };
        } else if (name === "pay_in_advance_enabled" && checked) {
          customerObj = {
            ...customerObj,
            payments_enabled: false,
            cod_payments_enabled: false,
          };
        }
      } else if (name.includes("cc_addresses")) {
        const [fieldName, index] = name.split("-");

        let ccAddressesMap =
          customerObj.cc_addresses === null ? [] : customerObj.cc_addresses;

        ccAddressesMap[index] = value;

        customerObj = {
          ...customerObj,
          [fieldName]: ccAddressesMap,
        };
      } else if (name.includes("_address")) {
        const [addressType, fieldName] = name.split("-");
        customerObj = {
          ...customerObj,
          [addressType]: {
            ...customerObj[addressType],
            [fieldName]: value,
          },
        };
      } else if (name.includes("order_days")) {
        const [fieldName, dayValue] = name.split("-");
        const currentDays = customerObj[fieldName] || [];

        if (checked) {
          customerObj = {
            ...customerObj,
            [fieldName]: [...currentDays, dayValue],
          };
        } else {
          customerObj = {
            ...customerObj,
            [fieldName]: currentDays.filter((item) => item !== dayValue),
          };
        }
      } else if (name === "delivery_time") {
        customerObj = { ...customerObj, [name]: value };
      } else {
        customerObj = { ...customerObj, [name]: value };
      }

      return customerObj;
    });
  };

  const handlePaymentTypeChange = (type) => {
    setPaymentType(type);

    setCustomer((prevState) => {
      let customerObj = { ...prevState };

      if (type === 1) {
        customerObj = {
          ...customerObj,
          payments_enabled: true,
          cod_payments_enabled: false,
          pay_in_advance_enabled: false,
        };
      } else if (type === 2) {
        customerObj = {
          ...customerObj,
          payments_enabled: false,
          cod_payments_enabled: true,
          pay_in_advance_enabled: false,
        };
      } else if (type === 3) {
        customerObj = {
          ...customerObj,
          payments_enabled: false,
          cod_payments_enabled: false,
          pay_in_advance_enabled: true,
        };
      } else {
        customerObj = {
          ...customerObj,
          payments_enabled: false,
          cod_payments_enabled: false,
          pay_in_advance_enabled: false,
        };
      }

      return customerObj;
    });
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to save the customer
          <b>{` ${customer.name}?`}</b>
          <br />
          <br />
          <div align="right">
            <Button onClick={() => toggleConfirmModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving customer information <br />
              This may take some time relative to the number of categories and
              fees configured
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the customer information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Customer information have been successfully saved
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const handleBack = () => {
    props.history.push("/customers");
  };

  const resolveRequest = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);

    toggleConfirmModal();

    if (!errorInfo.error) {
      props.history.push("/customers");
    }
  };

  const resolveError = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);
    setErrorInfo({ error: false, message: "" });
    toggleConfirmModal();
  };

  const sendRequest = async () => {
    setLoadingFlag(true);

    // todo: we might need to change this logic if we support multiple locations per company
    const ccAddressesMap =
      customer.cc_addresses === null
        ? customer.cc_addresses
        : customer.cc_addresses.filter((ccItem) => ccItem);

    const companyLocationPayload = {
      name: customer.name,
      phone_number: customer.phone_number,
      sales_tax_rate: customer.sales_tax_rate,
      refrigerated_delivery_fee: customer.refrigerated_delivery_fee,
      late_order_fee: customer.late_order_fee,
      credit_card_charge_fee: customer.credit_card_charge_fee,
      omit_delivery_fee_threshold: customer.omit_delivery_fee_threshold,
      taxable: customer.taxable,
      internal_notes: customer.internal_notes,
      qb_mapping: customer.qb_mapping,
      units_quickbooks_mappings: customer.units_quickbooks_mappings,
      fuel_surcharge: customer.fuel_surcharge,
      payments_enabled: customer.payments_enabled,
      lot_tracking_enabled: customer.lot_tracking_enabled,
      on_time_payment_days_threshold: customer.on_time_payment_days_threshold,
      on_time_payment_discount_amount: customer.on_time_payment_discount_amount,
      billing_address: customer.billing_address,
      physical_address: customer.physical_address,
      cc_addresses: ccAddressesMap,
      order_days: customer.order_days,
      delivery_time: customer?.delivery_time
        ? customer.delivery_time.length === 5
          ? customer.delivery_time + ":00"
          : customer.delivery_time
        : null,
      customer_editable_orderlist_enabled:
        customer.customer_editable_orderlist_enabled,
      cod_payments_enabled: customer.cod_payments_enabled,
      pay_in_advance_enabled: customer.pay_in_advance_enabled,
      operating_hours: customer.operating_hours,
      fuel_surcharge_fee: customer.fuel_surcharge_fee,
    };

    await backend
      .patch(
        `${API_URL}companylocations/${customer.id}`,
        companyLocationPayload,
      )
      .then(() => {
        setFinishedFlag(true);
        setLoadingFlag(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });
  };

  useEffect(() => {
    const customerGet = async () => {
      await backend
        .get(`${API_URL}companylocations/${customerId}`)
        .then(({ data }) => {
          let deliveryTime = "";

          if (data?.delivery_time) {
            const [hours, minutes] = data.delivery_time.split(":");
            deliveryTime = `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
          }

          const dataMap = {
            ...data,
            delivery_time: deliveryTime,
          };

          setCustomer(dataMap);
          setCustomerLoaded(true);

          const customerPaymentType = Boolean(dataMap.payments_enabled)
            ? 1
            : Boolean(dataMap.cod_payments_enabled)
              ? 2
              : Boolean(dataMap.pay_in_advance_enabled)
                ? 3
                : 0;

          setPaymentType(customerPaymentType);
        });
    };

    if (!isNaN(customerId) && !customerLoaded) {
      customerGet();
    }
  }, [customerId, customerLoaded]);

  return (
    <>
      <Container>
        <Modal open={confirmModal} onClose={toggleConfirmModal}>
          {confirmModalContent}
        </Modal>
        {currentUserStore?.is_staff === true && (
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button variant="contained" color="primary">
              <Typography variant="subtitle2" className="text-white">
                Customer Location
              </Typography>
            </Button>
            <Link to={`/customer/${customerId}/orderlists`}>
              <Button variant="contained" color="inherit">
                <Typography variant="subtitle2" color="black">
                  Order Guide
                </Typography>
              </Button>
            </Link>
            <Link to={`/customer/${customerId}/fees`}>
              <Button variant="contained" color="inherit">
                <Typography variant="subtitle2" color="black">
                  Fees
                </Typography>
              </Button>
            </Link>
          </Stack>
        )}
        <br />
        <Typography component="h6" variant="h6">
          {`${customerId ? "Edit" : "Add"} Customer Location ${
            customer.name || ""
          }`}
        </Typography>
        <CustomerForm
          {...props}
          customer={customer}
          paymentType={paymentType}
          handleChange={handleChange}
          handlePaymentTypeChange={handlePaymentTypeChange}
        />
        <br />
        <Stack direction="row" spacing={1} justifyContent="right">
          <Button onClick={handleBack}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => toggleConfirmModal()}
          >
            Save
          </Button>
        </Stack>
      </Container>
    </>
  );
};

export default CustomerAdd;
